export const routes = [
  {
    path: '/',
    name: 'home'
  },
  { path: '/sahara/regentes/',
    component: () => import('@/AppEndPoint'),
    props: true,
    children: [
      { 
        path: 'informe/:id',
        name: 'PageInformeRest',
        components: {
          default: () => import('@/pages/PlanPageWidget')
        }
      },
    ]
  },
  { path: '/:locale/',
    component: () => import('@/App'),
    props: true,
    children: 
    [ 
      {
        name: 'list',
        path: '',
        components: {
          header: () => import('@/components/Navbar'),
          default: () => import('@/pages/Home'),
          footer: () => import('@/components/Footer'),
        }
      },
      { 
        name: 'Plataforma',
        path: 'plataforma',
        components: {
          header: () => import('@/components/Navbar'),
          default: () => import('@/pages/Plataforma'),
          footer: () => import('@/components/Footer')
        }
      },
      {
        path: 'planes/',
        name: 'Planes',
        components: {
          header: () => import('@/components/Navbar'),
          default: () => import('@/pages/Planes'),
          footer: () => import('@/components/Footer')
        },
        props: true
      },
      {
        path: 'planes/saep',
        name: 'Planessaep',
        components: {
          default: () => import('@/pages/PlanesSaep')
        },
        props: true
      },
      { 
        path: 'planes/informes',
        name: 'PlanesInformes',
        components: {
          default: () => import('@/components/PlanesInformes')
        }, 
        props: true
      },
      { 
        path: 'planes/widget/:id/',
        name: 'PlanPageWidget',
        components: {
          default: () => import('@/pages/PlanPageWidget')
        }, 
        props: true
       },
      { 
        path: 'planes/:id/',
        name: 'PlanPageDetalles',
        components: {
          header: () => import('@/components/Navbar'),
          default: () => import('@/pages/PlanPageDetalles'),
          footer: () => import('@/components/Footer')
        }, 
        props: true
       },
      { 
        path: 'mapa/',
        name: 'MapaPage',
        components: {
          header: () => import('@/components/Navbar'),
          default: () => import('@/pages/MapaPage'),
          footer: () => import('@/components/Footer')
        },
        props: true 
      },
      { 
        path: 'contacto/',
        name: 'Contacto',
        components: {
          header: () => import('@/components/Navbar'),
          default: () => import('@/pages/Contacto'),
          footer: () => import('@/components/Footer')
        },
        props: true 
      },
      {
          path: 'involucrados/',
          name: 'Involucrados',
          components: {
            header: () => import('@/components/Navbar'),
            default: () => import('@/pages/Involucrados'),
            footer: () => import('@/components/Footer')
          },
          props: true 
      },
      { 
        path: 'involucrado/:id/',
        name: 'InvolucradoPage',
        components: {
          header: () => import('@/components/Navbar'),
          default: () => import('@/pages/InvolucradoPage'),
          footer: () => import('@/components/Footer')
        },
        props: true 
      },
      
    ]
    
  }
]

export default routes